// Kept apart from the snapshot builder so it stays off zod (eager bundle).

export type ViewContextGetter = () => Record<string, unknown> | undefined

export type HighlightedText = { text: string; windowId?: string }

/** The desktop's own board, reported like a window when nothing covers it. */
export const HOME_VIEW_ID = "desktop-home"

const getters = new Map<string, Map<string, ViewContextGetter>>()

export const registerViewContextGetter = ({
    windowId,
    key,
    getter,
}: {
    windowId: string
    key: string
    getter: ViewContextGetter
}): (() => void) => {
    const forWindow = getters.get(windowId) ?? new Map()
    forWindow.set(key, getter)
    getters.set(windowId, forWindow)
    return () => {
        const current = getters.get(windowId)
        if (current?.get(key) !== getter) {
            return
        }
        current.delete(key)
        if (current.size === 0) {
            getters.delete(windowId)
        }
    }
}

export const gettersOf = (
    windowId: string
): ReadonlyMap<string, ViewContextGetter> | undefined => getters.get(windowId)
